import { FieldValues, UseFieldArrayAppend } from 'react-hook-form';

import { AddFieldButton } from '@kanda-libs/ks-component-ts';

import { BASE_EMPLOYMENT } from './constants';

export interface AddEmploymentButtonProps {
  append: UseFieldArrayAppend<FieldValues, string>;
}

const AddEmploymentButton: React.FunctionComponent<AddEmploymentButtonProps> =
  function ({ append }) {
    return (
      <div className="mx-auto border border-dashed border-neutral-300 rounded-lg justify-center pt-3 px-4 mb-5 mt-2">
        <AddFieldButton
          label="Add more employment info"
          onClick={() => append(BASE_EMPLOYMENT)}
        />
      </div>
    );
  };

export default AddEmploymentButton;
